import { dynamicTextDataQuery } from './dynamicTextDataQuery';
import { internalLinkReference } from './linkQueries';

export const portableTextWithReferences = `
...,
children[] {
  ...,
  ${dynamicTextDataQuery}
},
markDefs[] {
  ...,
  reference->{${internalLinkReference}},
  newWindow,
  'internalAnchor': internalAnchor.internal
}
`
